export const itemsList = [
    {
        id: 'fsrbo.generic.hero.list.item1',
        text: 'fsrbo.generic.hero.list.item1',
    },
    {
        id: 'fsrbo.generic.hero.list.item2',
        text: 'fsrbo.generic.hero.list.item2',
    },
    {
        id: 'fsrbo.generic.hero.list.item3',
        text: 'fsrbo.generic.hero.list.item3',
    },
];
